import React from "react";
import { CongLayout } from "assets/js/Styles";
import Navbar from "./navbar";

const Layout3 = ({ children }) => {
  return (
    <CongLayout>
      <Navbar />
      {children}
    </CongLayout>
  );
};

export default Layout3;
